import {
	Keyboard,
	KeyboardResize as Resize,
	KeyboardStyle as Style,
} from '@capacitor/keyboard';
import mitt from 'mitt';

// plugin's methods
const methods = [
	'show',
	'hide',
	'setAccessoryBarVisible',
	'setScroll',
	'setStyle',
	'setResizeMode',
	'getResizeMode',
];

// plugin's listeners
const emitter = mitt();
const events = [
	'keyboardWillShow',
	'keyboardDidShow',
	'keyboardWillHide',
	'keyboardDidHide',
];

Keyboard.removeAllListeners();

events.forEach(event => {
	Keyboard.addListener(event, data => {
		emitter.emit(event, data);
	});
});

export function useNativeKeyboard () {
	// methods
	const api = methods.reduce((api, name) => {
		api[name] = Keyboard[name];
		return api;
	}, {});

	// custom listener
	function addListener (event, callback) {
		emitter.on(event, callback);
		return () => emitter.off(event, callback);
	}

	// custom remove all listeners
	function removeAllListeners () {
		emitter.all.clear();
	}

	return {
		...api,
		addListener,
		removeAllListeners,
	};
}

export const KeyboardResize = Resize;
export const KeyboardStyle = Style;
